import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/auth.store';

const routes: RouteRecordRaw[] = [
	{
		path: '/login',
		name: 'login',
		component: () => import('@/pages/LoginPage.vue'),
		meta: { public: true }
	},
	{
		path: '/',
		component: () => import('@/layouts/AdminLayout.vue'),
		children: [
			{ path: '', redirect: { name: 'dashboard' } },
			{ path: 'dashboard', name: 'dashboard', component: () => import('@/pages/DashboardPage.vue') },
			{ path: 'donations', name: 'donations', component: () => import('@/pages/DonationsPage.vue') },
			{ path: 'balances', name: 'balances', component: () => import('@/pages/BalancesPage.vue') },
			{ path: 'streamers', name: 'streamers', component: () => import('@/pages/StreamersPage.vue') },
			{ path: 'streamers/:userId', name: 'streamer', component: () => import('@/pages/StreamerProfilePage.vue') },
			{ path: 'event-changes', name: 'event-changes', component: () => import('@/pages/EventChangeLogsPage.vue') },
			{ path: 'broken-events', name: 'broken-events', component: () => import('@/pages/BrokenEventsPage.vue') },
			{ path: 'payouts', name: 'payouts', component: () => import('@/pages/PayoutsPage.vue'), meta: { title: 'Выплаты' } },
			{ path: 'trait-groups', name: 'trait-groups', component: () => import('@/pages/TraitGroupsPage.vue'), meta: { title: 'Группы черт' } },
			{ path: 'commission-settings', name: 'commission-settings', component: () => import('@/pages/CommissionSettingsPage.vue'), meta: { title: 'Комиссия Platega' } },
			{ path: 'platform-share-settings', name: 'platform-share-settings', component: () => import('@/pages/PlatformShareSettingsPage.vue'), meta: { title: 'Доля платформы' } },
			{ path: 'reviews', name: 'reviews', component: () => import('@/pages/ReviewsPage.vue'), meta: { title: 'Отзывы' } },
			{ path: 'payment-feedback', name: 'payment-feedback', component: () => import('@/pages/PaymentFeedbackPage.vue'), meta: { title: 'Проблемы оплаты' } },
			{ path: 'chargebacks', name: 'chargebacks', component: () => import('@/pages/PlaceholderPage.vue'), meta: { title: 'Чарджбеки' } },
			{ path: 'reports', name: 'reports', component: () => import('@/pages/PlaceholderPage.vue'), meta: { title: 'Отчёты' } },
			{ path: 'audit-log', name: 'audit-log', component: () => import('@/pages/AuditLogPage.vue') }
		]
	},
	{ path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/pages/NotFoundPage.vue') }
];

export const router = createRouter({
	history: createWebHistory(),
	routes
});

router.beforeEach(async to => {
	const auth = useAuthStore();
	if (!auth.initialized) {
		await auth.fetchMe();
	}

	const isPublic = to.matched.some(record => record.meta?.public);
	if (!isPublic && !auth.isAuthenticated) {
		return { name: 'login', query: { redirect: to.fullPath } };
	}
	if (isPublic && auth.isAuthenticated && to.name === 'login') {
		return { name: 'dashboard' };
	}
	return true;
});
